import * as React from "react";

import { Inline, Text } from "@seneca/senekit";

import { Icon, IconType } from "features/common/icons";

import { Color } from "../../../consts";
import TextClickHandler from "../../TextClickHandler";
import styles from "./IconClickHandler.module.scss";

type Props = {
  onClick?: () => void;
  text?: string | React.ReactNode;
  color?: Color | string | null | undefined;
  className?: string;
  icon: IconType;
};

export default function IconClickHandler({
  text,
  className,
  onClick,
  color,
  icon
}: Props) {
  return (
    <TextClickHandler
      underlineOnHover
      onClick={onClick}
      className={className}
      color={color}
    >
      <Inline alignItems="center">
        <Icon icon={icon} className={styles.icon} />
        <Text>{text}</Text>
      </Inline>
    </TextClickHandler>
  );
}
